import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PartnerAgreementText from "@/components/PartnerAgreementText";
import { PARTNER_AGREEMENT_SECTIONS, AGREEMENT_VERSION } from "@/lib/partnerAgreement";
import { Download, Scale } from "lucide-react";

/**
 * Iteration 294 — public "PTA & Charity Partner Terms" page
 * (/legal/partner-agreement): the full 6-section Commercial Participation
 * Agreement with a plain-text download for partner records.
 */
export default function PartnerAgreementPage() {
  const download = () => {
    const text = [
      "MyTableTopApp — Commercial Participation Agreement (PTA & Charity Partner Terms)",
      `Version ${AGREEMENT_VERSION} · Digitally Prepared Ltd (t/a MyTableTopApp)`,
      "",
      ...PARTNER_AGREEMENT_SECTIONS.flatMap((s) => [
        `Section ${s.n}: ${s.title}`,
        ...s.body,
        "",
      ]),
    ].join("\n");
    const blob = new Blob([text], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `mytabletopapp-partner-agreement-v${AGREEMENT_VERSION}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="min-h-screen bg-[#FFFDF7]">
      <Navbar />
      <section className="max-w-3xl mx-auto px-6 lg:px-8 py-12" data-testid="partner-agreement-page">
        <div className="pill bg-brandTeal/15 text-brandTeal inline-flex items-center gap-1.5">
          <Scale className="w-3.5 h-3.5" /> Legal
        </div>
        <h1 className="font-display text-4xl md:text-5xl font-semibold text-slate-900 mt-3">PTA &amp; Charity Partner Terms</h1>
        <p className="text-slate-600 mt-2">
          The Commercial Participation Agreement between Digitally Prepared Ltd (t/a MyTableTopApp) and registered partner organizations — PTAs, schools, charities, youth &amp; sports clubs, community groups and corporate sponsors.
        </p>
        <button
          type="button"
          onClick={download}
          className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-xl border border-brandTeal text-brandTeal text-sm font-bold hover:bg-brandTeal hover:text-white transition"
          data-testid="partner-agreement-download"
        >
          <Download className="w-4 h-4" /> Download agreement (v{AGREEMENT_VERSION})
        </button>
        <div className="card-base p-6 md:p-10 mt-6">
          <PartnerAgreementText />
        </div>
      </section>
      <Footer />
    </div>
  );
}
